__turbopack_context__.v({
  "bottomNote": "photon-client-module__AhVMVa__bottomNote",
  "noteSeparator": "photon-client-module__AhVMVa__noteSeparator",
  "root": "photon-client-module__AhVMVa__root",
});
